var exports = {
  "kL": "CompactVoiceCallView.module__container___MjlJdy",
  "gw": "CompactVoiceCallView.module__containerNoHeader___MjlJdy",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___MjlJdy",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___MjlJdy",
  "ap": "CompactVoiceCallView.module__containerFillHeight___MjlJdy",
  "tZ": "CompactVoiceCallView.module__contentArea___MjlJdy",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___MjlJdy",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___MjlJdy",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___MjlJdy",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___MjlJdy",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___MjlJdy",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___MjlJdy",
  "D9": "CompactVoiceCallView.module__layoutHost___MjlJdy",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___MjlJdy",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___MjlJdy",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___MjlJdy",
  "_t": "CompactVoiceCallView.module__controlBarSection___MjlJdy",
  "Vw": "CompactVoiceCallView.module__controlBarInner___MjlJdy",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___MjlJdy",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___MjlJdy",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___MjlJdy",
  "x8": "CompactVoiceCallView.module__heightTogglePill___MjlJdy",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___MjlJdy",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___MjlJdy",
  "Di": "CompactVoiceCallView.module__resizeHandle___MjlJdy",
  "YC": "CompactVoiceCallView.module__resizePill___MjlJdy",
  "$I": "CompactVoiceCallView.module__containerResizing___MjlJdy",
};

module.exports = exports;
